import { Navigate } from 'react-router-dom';
import { useUserPreferences } from '@/features/dashboard/hooks/useDashboard';
import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';

/**
 * Redirects to the user's configured landing page:
 * - /dashboard if dashboard is enabled
 * - /projects otherwise
 */
export default function LandingRedirect() {
  const { preferences, loading } = useUserPreferences();

  if (loading) return <LoadingSpinner />;

  const dashboardEnabled = preferences?.dashboard_preferences?.enabled ?? false;

  return <Navigate to={dashboardEnabled ? '/dashboard' : '/projects'} replace />;
}
